<!-- =========================================================================================
  File Name: ClientEditTabSettings.vue
  Description: Client Edit Tab Settings page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Webspiders
  Author URL: https://www.webspiders.com
========================================================================================== -->
<style lang="scss">
.div-hr {
  width: 100%;
  padding: 15px 0;
  border-bottom: 1px solid #cdcdcd;
}
.con-img-upload {
  background: #efeeee;
}
.custom-domain-wrap {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.input-wdt {
  width: 70%;
  margin-right: 15px;
}
.auth-check {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.button-wrap {
  text-align: right;
}
</style>
<template>
  <div id="client-edit-tab-settings">
    <h3 class="my-5">Client Settings</h3>
    <div class="vx-row mb-6">
      <div class="vx-col md:w-1/2 w-full mt-4">
        <label>Upload Favicon</label>
        <img :src="favicon" class="mr-8 rounded h-24 w-24" />
        <input
          type="file"
          class="hidden"
          ref="update_favicon_input"
          @change="update_favicon"
          accept="image/*"
        />
        <vs-button class="mr-4 mb-4" @click="$refs.update_favicon_input.click()"
          >Upload Favicon</vs-button
        >
      </div>

      <div class="vx-col md:w-1/2 w-full mt-4">
        <label>Info Text</label>
        <quill-editor
          label="Info Text"
          class="inputx w-full"
          name="Info Text"
          v-model="data_local.Infotext"
        ></quill-editor>
      </div>

      <div class="vx-col sm:w-1/2 w-full md:mt-2 name-evnt">
        <!-- <vs-input
          class="w-full"
          label="Privacy Policy URL"
          name="Privacy Policy URL"
          v-model="data_local.PrivacyPolicyURL"
        />-->
        <div class="auth-check">
          <label class="mr-5 mt-2">SSO Enabled</label>
          <vs-switch v-model="data_local.SSOEnabled" name="SSOEnabled">
            <span slot="true">True</span>
            <span slot="false">False</span>
          </vs-switch>
        </div>
        <div class="auth-check">
          <label class="mr-5 mt-2">ReCAPTCHA</label>
          <vs-switch v-model="data_local.reCAPTCHA" name="reCAPTCHA ">
            <span slot="true">True</span>
            <span slot="false">False</span>
          </vs-switch>
        </div>
        <!-- <vs-input class="w-full" label="Info Text" name="Info Text" v-model="data_local.Infotext" /> -->
      </div>

      <div class="vx-col sm:w-1/2 w-full md:mt-2 name-evnt">
        <!-- <vs-input
          class="w-full"
          label="Term of Use URL"
          name="Term of Use URL"
          v-model="data_local.TermofUseURL"
        />-->

        <label>Terms Of Use Text</label>
        <quill-editor
          label="Terms Of Use Text"
          name="Terms Of Use Text"
          class="inputx w-full"
          v-model="data_local.TermsOfUseText"
        ></quill-editor>
      </div>

      <div class="vx-col md:w-1/2 w-full mt-4">
        <div class="auth-check">
          <label class="mr-5 mt-2">Social Authorization</label>
          <vs-checkbox
            v-model="data_local.SocialAuths[0].Google"
            class="mt-2 mr-5"
            >Google</vs-checkbox
          >
          <vs-checkbox
            v-model="data_local.SocialAuths[0].LinkedIn"
            class="mt-2 mr-5"
            >LinkedIn</vs-checkbox
          >
          <vs-checkbox
            v-model="data_local.SocialAuths[0].Microsoft"
            class="mt-2 mr-5"
            >Microsoft</vs-checkbox
          >
            <vs-checkbox
            v-model="data_local.SocialAuths[0].Facebook"
            class="mt-2 mr-5"
            >Facebook</vs-checkbox
          >
        </div>
      </div>
      <div class="vx-col md:w-1/1 w-full mt-4">
        <div class="auth-check">
          <label class="mr-5 mt-2">Use Custom SMTP</label>
          <vs-switch v-model="data_local.CustomSMTP" name="Custom SMTP">
            <span slot="true">True</span>
            <span slot="false">False</span>
          </vs-switch>
        </div>
      </div>
      <div class="vx-col md:w-1/2 w-full mt-4" v-show="!data_local.CustomSMTP">
        <div class="auth-check">
          <vs-input
            class="w-full"
            label="SENDGRID Base Url"
            name="SENDGRIDBaseUrl"
            v-model="data_local.SENDGRIDBaseUrl"
          />
        </div>
      </div>
      <div class="vx-col md:w-1/2 w-full mt-4" v-show="!data_local.CustomSMTP">
        <div class="auth-check">
          <vs-input
            class="w-full"
            label="SENDGRID Api Key"
            name="SENDGRIDApiKey"
            v-model="data_local.SENDGRIDApiKey"
          />
        </div>
      </div>
      <div class="vx-col md:w-1/2 w-full mt-4" v-show="data_local.CustomSMTP">
        <div class="auth-check">
          <vs-input
            class="w-full"
            label="SMTP Server Address"
            name="SMTP Server Address"
            placeholder="e.g smtp.gmail.com"
            v-model="data_local.SMTPServerAddress"
          />
        </div>
      </div>
      <div class="vx-col md:w-1/2 w-full mt-4" v-show="data_local.CustomSMTP">
        <div class="auth-check">
          <vs-input
            class="w-full"
            label="User Name"
            placeholder="e.g johndoe@example.com"
            v-model="data_local.SMTPUserName"
          />
        </div>
      </div>
      <div class="vx-col md:w-1/2 w-full mt-4" v-show="data_local.CustomSMTP">
        <div class="auth-check">
          <vs-input
            class="w-full"
            label="Password"
            placeholder="Type your password here"
            v-model="data_local.SMTPPassword"
          />
        </div>
      </div>
      <div class="vx-col md:w-1/2 w-full mt-4" v-show="data_local.CustomSMTP">
        <div class="auth-check">
          <vs-input
            class="w-full"
            label="Encryption Type"
            placeholder="e.g SSL, TLS"
            v-model="data_local.SMTPEncryptionType"
          />
        </div>
      </div>
      <div class="vx-col md:w-1/2 w-full mt-4" v-show="data_local.CustomSMTP">
        <div class="auth-check">
          <vs-input
            class="w-full"
            label="Port Number"
            placeholder="e.g 465, 587"
            v-model="data_local.SMTPPortNumber"
          />
        </div>
      </div>
      <div class="vx-col md:w-1/1 w-full mt-4">
        <div class="auth-check">
          <label class="mr-5 mt-2">CRM Integration</label>
          <vs-switch
            v-model="data_local.crm_integration.IsPublished"
            name="CRM Integration"
          >
            <span slot="true">True</span>
            <span slot="false">False</span>
          </vs-switch>
        </div>
      </div>
      <div
        class="vx-col md:w-1/2 w-full mt-4"
        v-show="data_local.crm_integration.IsPublished"
      >
        <div class="auth-check mt-6">
          <label class="mr-5">Source</label>
          <v-select
            class="w-full"
            v-model="data_local.crm_integration.source"
            :options="['eloqua']"
          />
        </div>
      </div>
      <div
        class="vx-col md:w-1/2 w-full mt-4"
        v-show="data_local.crm_integration.IsPublished"
      >
        <div class="auth-check">
          <vs-input
            class="w-full"
            label="Env"
            v-model="data_local.crm_integration.credentials.env"
          />
        </div>
      </div>
      <div
        class="vx-col md:w-1/2 w-full mt-4"
        v-show="data_local.crm_integration.IsPublished"
      >
        <div class="auth-check">
          <vs-input
            class="w-full"
            label="Password"
            v-model="data_local.crm_integration.credentials.password"
          />
        </div>
      </div>
      <div
        class="vx-col md:w-1/2 w-full mt-4"
        v-show="data_local.crm_integration.IsPublished"
      >
        <div class="auth-check">
          <vs-input
            class="w-full"
            label="Sitename"
            v-model="data_local.crm_integration.credentials.sitename"
          />
        </div>
      </div>
      <div
        class="vx-col md:w-1/2 w-full mt-4"
        v-show="data_local.crm_integration.IsPublished"
      >
        <div class="auth-check">
          <vs-input
            class="w-full"
            label="Username"
            v-model="data_local.crm_integration.credentials.username"
          />
        </div>
      </div>

      <div class="vx-row w-full">
        <div class="div-hr w-full"></div>
      </div>

      <div class="vx-col md:w-1/2 w-full mt-4">
        <div class="auth-check mt-6">
          <label class="mr-5">Default Landing Page</label>
          <v-select
            class="w-full"
            v-model="defaultLandingPageModel"
            :options="defaultLandingPage"
          />
        </div>
      </div>

      <div 
        class="vx-col md:w-1/2 w-full mt-4"
        v-if="defaultLandingPageModel.value == 'customlanding'">
        <div class="auth-check mt-6">
          <label class="mr-5">Default Event</label>
          <v-select
            class="w-full"
            v-model="defaultEvent"
            label="EventFullName"
            :options="clientsEventList"
          />
        </div>
      </div>

      <div
        class="vx-col md:w-1/2 w-full md:mt-2 name-evnt"
        v-if="defaultLandingPageModel.value == '/events'"
      >
        <div class="auth-check">
          <label class="mr-5 mt-2">Show Create Event Button</label>
          <vs-switch v-model="showCreateEventButton" name="createEvent">
          </vs-switch>
        </div>
      </div>

      <div
        class="vx-col md:w-1/2 w-full mt-4"
        v-if="defaultLandingPageModel.value == '/events'"
      >
        <div class="auth-check">
          <vs-input
            class="w-full"
            label="Font Family Name"
            v-model="eventListingFont"
          />
        </div>
      </div>

      <div
        class="vx-col md:w-1/2 w-full md:mt-2 name-evnt"
        v-if="defaultLandingPageModel.value == '/events'"
      >
        <div class="auth-check">
          <label class="mr-5 mt-2">Enable Add to Calender</label>
          <vs-switch v-model="addToCalender" name="addToCalender"> </vs-switch>
        </div>
      </div>

      <div
        class="vx-col md:w-1/2 w-full mt-4"
        v-if="defaultLandingPageModel.value == '/events'"
      >
        <div class="auth-check">
          <vs-input
            class="w-full"
            label="No. of Events to display per section"
            type="number"
            v-model="displayEventsPerSection"
          />
        </div>
      </div>

      <div
        class="vx-col md:w-1/2 w-full md:mt-2 name-evnt"
        v-if="defaultLandingPageModel.value == '/events'"
      >
        <div class="auth-check">
          <label class="mr-5 mt-2">Enable Event Filter</label>
          <vs-switch v-model="enableEventFilter" name="eventFilter">
          </vs-switch>
        </div>
      </div>

      <div
        class="vx-col md:w-1/2 w-full md:mt-2 name-evnt"
        v-if="defaultLandingPageModel.value == '/events'"
      >
        <div class="auth-check">
          <label class="mr-5 mt-2">Show SignIn in pop-up</label>
          <vs-switch v-model="showSignInPopup" name="signInPopup"> </vs-switch>
        </div>
      </div>

      <div class="vx-col md:w-1/2 w-full mt-4">
        <div class="auth-check mt-6">
          <label class="mr-5">Streaming Client</label>
          <v-select
            class="w-full"
            :clearable="false"
            v-model="StreamingClient"
            label="Name"
            :options="[{Name:'Web',Val:'Web'},{Name:'ZoomClient',Val:'Zoom'},{Name:'ZoomWeb',Val:'ZoomWeb'}]"
            :reduce="(option) => option.Val"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
          />
        </div>
      </div>

      <div class="vx-col md:w-1/2 w-full mt-2">
        <label>Approval Type</label>
          <v-select
            class="mt-3"
            label="Name"
            :clearable="false"
            :options="[
              {Name:'Open Meeting', id:2},
              //{Name:'Need Approval', id:1},
              {Name:'Need Registration', id:0}
            ]"
            :reduce="(option) => option.id"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            v-model="approval_type"
          />
      </div>
      <div class="vx-col md:w-1/2 w-full mt-2">
          <vs-input
            class="w-full"
            label="Meta Title"
            v-model="MetaTitle"
          />
      </div>
      <div class="vx-col md:w-1/2 w-full mt-2">
          <vs-input
            class="w-full"
            label="Meta Description"
            v-model="MetaDescription"
          />
      </div>
      <div class="vx-col md:w-1/2 w-full mt-2">
          <vs-input
            class="w-full"
            label="Meta Keywords"
            v-model="MetaKeywords"
          />
      </div>
      <div class="vx-col md:w-1/2 w-full mt-4">
        <label>Meta Image</label>
        <div class="flex flex-wrap items-center justify-start">
          <img v-if="MetaImage" :src="MetaImage" class="mr-8 rounded h-24 w-24" />
          <vs-input
            class="w-1/3"
            type="file"
            @change="update_metaimage"
            accept="image/*"
          />
        </div>        
      </div>

      <div class="vx-col md:w-1-12 w-full mt-5 button-wrap">
        <vs-button class="mr-3 mb-2" @click="save_changes">Save</vs-button>
      </div>
    </div>
  </div>
</template>
<script>
import vSelect from "vue-select";
import "quill/dist/quill.snow.css";
import { quillEditor } from "vue-quill-editor";
export default {
  components: { quillEditor, "v-select": vSelect },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      defaultLandingPage: [
        { label: "Login Page", value: "/" },
        { label: "Event Hub", value: "/events" },
        { label: "Showcase Events", value: "/showcase" },
        { label: "Custom Landing", value: "customlanding" }
      ],
      data_local: JSON.parse(JSON.stringify(this.data)),
      favicon: null,
      defaultLandingPageModel: [{ label: "Login", value: "/" }],
      showCreateEventButton: false,
      eventListingFont: "",
      addToCalender: false,
      displayEventsPerSection: 6,
      enableEventFilter: false,
      showSignInPopup: false,
      StreamingClient: 'Zoom',
      approval_type: 2,    
      defaultEvent: null,
      MetaTitle: null,
      MetaDescription: null,
      MetaKeywords: null,
      MetaImage: null,
      clientsEventList: []  
    };
  },

  methods: {
    update_favicon(input) {
      if (input.target.files && input.target.files[0]) {
        let file = input.target.files[0];
        var metadata = {
          contentType: file.type,
        };

        let validImageTypes = [
          "image/gif",
          "image/jpeg",
          "image/png",
          "image/ico",
          "image/x-icon",
        ];
        if (!validImageTypes.includes(file.type)) {
          alert("Only gif,jpeg,ico & png file allowed.");
          return false;
        }

        this.data_local.faviconFile = file;
        const reader = new FileReader();
        reader.onload = (e) => {
          this.favicon = e.target.result;
        };
        reader.readAsDataURL(input.target.files[0]);
      }
    },
    update_metaimage(input) {
      if (input.target.files && input.target.files[0]) {
        let file = input.target.files[0];
        var metadata = {
          contentType: file.type,
        };

        let validImageTypes = [
          "image/gif",
          "image/jpeg",
          "image/png",
          "image/ico",
          "image/x-icon",
        ];
        if (!validImageTypes.includes(file.type)) {
          alert("Only gif,jpeg,ico & png file allowed.");
          return false;
        }
        this.data_local.metaimageFile = file;
        const reader = new FileReader();
        reader.onload = (e) => {
          this.MetaImage = e.target.result;
        };
        reader.readAsDataURL(input.target.files[0]);
      }
    },
    save_changes() {
      // Here will go your API call for updating data
      // You can get data in "this.data_local"

      this.$vs.loading();

      /* eslint-enable */

      this.data_local.defaultLandingPageModel =
        this.defaultLandingPageModel.value == undefined
          ? "/"
          : this.defaultLandingPageModel.value;
      this.data_local.showCreateEventButton = this.showCreateEventButton;
      this.data_local.EventListAssets.eventListingFont = this.eventListingFont;
      this.data_local.addToCalender = this.addToCalender;
      this.data_local.displayEventsPerSection = this.displayEventsPerSection;
      this.data_local.enableEventFilter = this.enableEventFilter;
      this.data_local.showSignInPopup = this.showSignInPopup;
      this.data_local.StreamingClient = this.StreamingClient;
      this.data_local.approval_type = this.approval_type;
      this.data_local.defaultEvent = this.defaultLandingPageModel.value == 'customlanding' ? this.defaultEvent : null;
      this.data_local.MetaTitle = this.MetaTitle;
      this.data_local.MetaDescription = this.MetaDescription;
      this.data_local.MetaKeywords = this.MetaKeywords;
      //this.data_local.MetaImage = this.MetaImage;

      const Id = this.$route.params.clientId;
      if (Id) {
        this.$store
          .dispatch("clientManagement/updateSettings", {
            id: Id,
            data: this.data_local,
          })
          .then((res) => {
            this.$vs.notify({
              position: "top-center",
              color: "success",
              title: "Client",
              text: res.message,
            });
            this.$vs.loading.close();
          })
          .catch((err) => {
            this.$vs.loading.close();
            console.error(err);
          });
      }
    },
  },
  async created(){
    await this.$store.dispatch("clientManagement/fetchClientsEventList", this.$route.params.clientId).then((res) => {
      this.clientsEventList = res;
    })
  },
  mounted() {
    console.log("data_local>>>>>>>", this.data_local);
    if (this.data_local.DefaultLandingPage != undefined) {
      if (this.data_local.DefaultLandingPage == "/") {
        this.defaultLandingPageModel = { label: "Login", value: "/" };
      } else {
        //this.defaultLandingPageModel = { label: "Events", value: "/events" };
        for(let item of this.defaultLandingPage){
          if(this.data_local.DefaultLandingPage == item.value)
            this.defaultLandingPageModel = item;
        }
      }

      this.showCreateEventButton =
        this.data_local.clientSettings.ShowCreateEventButton;
      this.addToCalender = this.data_local.clientSettings.AddToCalender;
      this.displayEventsPerSection =
        this.data_local.clientSettings.DisplayEventsPerSection;
      this.enableEventFilter = this.data_local.clientSettings.EnableEventFilter;
      this.showSignInPopup = this.data_local.clientSettings.ShowSignInPopup;
      this.approval_type = this.data_local.clientSettings.approval_type != undefined ? this.data_local.clientSettings.approval_type : 2;
      this.StreamingClient = this.data_local.clientSettings.StreamingClient ? this.data_local.clientSettings.StreamingClient : 'Zoom';
      this.eventListingFont = this.data_local.EventListAssets.eventListingFont;
      this.defaultEvent = this.data_local.defaultEvent;
      this.MetaTitle = this.data_local.MetaTitle || null;
      this.MetaDescription = this.data_local.MetaDescription || null;
      this.MetaKeywords = this.data_local.MetaKeywords || null;
      this.MetaImage = this.data_local.MetaImage || null;
    }
  },
};
</script>